import { PublicationTypeE } from './bookPartLink';
import { PublicationStatusE } from './document';
import { BookTypeE } from './book';

export const FAVORITES_FOLDER_NAME_MAX_LENGTH = 255;

export interface FavoritesFolderI {
    id: number;
    name: string;
    createdAt?: string;
    publicationCount?: number;
    lastUpdateDate?: string;
}

export interface FavoritesFileI {
    id: number;
    publicationType: PublicationTypeE;
    publicationId: number;
    favoritesFolderId?: number;
    favoritesFolderName?: string;
    creationDate?: string;
    title?: string;
    reference?: string;
    version?: number;
    userStatus?: PublicationStatusE;
    // Only ever set when publicationType is BOOK (a whole book, as opposed to a BOOKPART chapter), to tell
    // a monograph apart from a periodical.
    bookType?: BookTypeE;
    // Only ever set when publicationType is BOOK: there is no page for a whole book, so the detail link
    // navigates into this book part instead.
    firstBookPartId?: number;
    // Only ever set when publicationType is BOOKPART, to show which book the chapter belongs to.
    bookTitle?: string;
    // Only ever set when publicationType is BOOK or BOOKPART: the whole book's id.
    bookId?: number;
    // Mirrors PublicationI.partner.
    partner?: string;
    // Mirrors PublicationI.typeCode ("empty" when publicationType is BOOK or BOOKPART).
    documentTypeCode?: string;
}

export enum FavoritesSortFieldE {
    NAME = 'name',
    DATE_ADDED = 'dateAdded'
}

export type FavoritesSortDirectionT = 'asc' | 'desc';

export interface AddPublicationToFavoritesPayloadI {
    publicationId: number;
    publicationType: PublicationTypeE;
    favoritesFolderId?: number | null;
}

// Report of a bulk "add a whole favorites folder" operation into a project or a folder.
export interface BulkAddFavoritesResultI {
    addedCount: number;
    alreadyPresentCount: number;
}
